export default __webpack_public_path__ + "QuickSuite-logo-active.1f61ec1d.svg";